import { graphClient } from '../graph-client'
import type { LiveCheckinMonthTask } from '../../types/check-in'
import type { Response } from '../../types/response'
import { DO_LIVE_CHECKIN, GET_LIVE_CHECKINS_MONTHS_TASKS } from './gql'

export namespace GetList {
  export interface Input {
    take?: number
    skip?: number
    liveCheckinMonthId?: number
    userId?: number
    completed?: boolean
  }
  export interface Output {
    getLiveCheckinsMonthsTasks: Response<LiveCheckinMonthTask[]>
  }
}

export namespace DoCheckin {
  export interface Input {
    userId: number
  }
  export interface Output {
    doLiveCheckin: {
      status: string
      error: string | null
      alreadyToday: boolean
    }
  }
}

class LiveCheckinMonthsTasksService {
  async getList(params: GetList.Input) {
    const res = await graphClient.request<GetList.Output>(
      GET_LIVE_CHECKINS_MONTHS_TASKS,
      params,
    )
    return res?.getLiveCheckinsMonthsTasks
  }

  async doCheckin(params: DoCheckin.Input) {
    const res = await graphClient.request<DoCheckin.Output>(
      DO_LIVE_CHECKIN,
      params,
    )
    return res?.doLiveCheckin
  }
}

export const liveCheckinMonthsTasksService = new LiveCheckinMonthsTasksService()
